import * as tokens from '@joinrepublic/dls-ui-core';
import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

import { componentStyles } from './component-styles';

type IThemeLike = Record<string, unknown>;

const getAllPaths = (obj: IThemeLike, prefix = ''): string[] => {
  return Object.entries(obj).flatMap(([key, value]) => {
    const path = prefix
      ? key.includes('.')
        ? `${prefix}["${key}"]`
        : `${prefix}.${key}`
      : key;

    if (isPlainObject(value)) {
      return getAllPaths(value as IThemeLike, path);
    }

    return [path];
  });
};

export const validateChildTheme = (
  childTheme: IThemeLike,
  childThemeName = 'child'
): string[] => {
  const mismatches: string[] = [];
  const dlsComponents = Object.keys(componentStyles);
  const childComponents = Object.keys(
    (childTheme.components as IThemeLike | undefined) ?? {}
  );

  if (dlsComponents.length > 0) {
    const missingComponents = dlsComponents.filter(
      (component) => !childComponents.includes(component)
    );

    for (const component of missingComponents) {
      mismatches.push(
        `Missing component -> '${component}' in ${childThemeName} theme`
      );
    }
  }

  const dlsKeys = getAllPaths(tokens.dls as IThemeLike);
  const childKeys = new Set(getAllPaths(childTheme));

  for (const key of dlsKeys) {
    if (!childKeys.has(key) && get(childTheme, key) === undefined) {
      mismatches.push(`Missing key -> '${key}' in ${childThemeName} theme`);
    }
  }

  return mismatches;
};
